import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  seasons: [],
};

export const hiringSlice = createSlice({
  name: "hiring",
  initialState,
  reducers: {
    setHiringSeasons: (state, action) => {
      state.seasons = action.payload;
    },
    clearHiringSeasons: (state) => {
      state.seasons = [];
    },
  },
});

export const { setHiringSeasons, clearHiringSeasons } = hiringSlice.actions;
export default hiringSlice.reducer;
